<div *ngIf="timerType === 'server'">
    <div class="timer"><i class="fa-solid fa-hourglass"></i> {{ remainingTime | async | timer }}</div>
</div>

<div *ngIf="timerType === 'client'">
    <div class="timer"><i class="fa-solid fa-hourglass"></i> {{ remainingTime | async | timer }}</div>
</div>